import { render } from "./ActionEmail.vue?vue&type=template&id=6fda8666"
import script from "./ActionEmail.vue?vue&type=script&lang=js"
export * from "./ActionEmail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__